/**
 * Canonical numeric type treatment for data surfaces: the Inter UI stack
 * with ``tabular-nums``, so digits are fixed-width and column-align like a
 * monospace font without the typewriter look.
 *
 * Single source of truth - consumed by:
 * - ``utils/tableFormatters.ts`` ``getColumnStyle`` (every DataViewTable
 *   + platform report cell, which covers the pricing columns)
 * - ``config/exceptions/shared/OutletMetricCell.tsx`` (per-outlet cells)
 * - the Compare Sales surface via ``COMPARE_NUM_FONT_SX`` (re-exported from
 *   ``components/inspector/shared/compareSalesPalette.tsx``)
 *
 * Update here and every numeric surface updates together.
 */
export const NUMERIC_FONT_SX = {
  fontFamily:
    "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
  fontVariantNumeric: 'tabular-nums',
} as const
